import TutorialImage1 from "@/assets/images/tutorial-image1.png";

import { useTranslation } from "react-i18next";

function Page1() {
  const { t } = useTranslation("New");

  return (
    <div className="w-full">
      <div className="flex flex-col gap-4 items-center">
        <div className="w-[500px] h-[250px]">
          <img src={TutorialImage1} alt="tutorial" />
        </div>
      </div>

      <div className="flex flex-col gap-4 mt-13">
        <p className="font-medium text-center">{t("onboardingDesc1")}</p>
      </div>
    </div>
  );
}

export default Page1;
